import { getDiffArray, filterDiffFunction } from './chunk-RPUBZJ2D.mjs';
import { selectItems } from './chunk-PHOCK55S.mjs';
import { i18n_config_default } from './chunk-SGCJ7UYI.mjs';

// src/helpers/factories/menuDifferences/diffItemGroupsFactory.ts
var ItemGroupBasicSectionFieldLabels = /* @__PURE__ */ ((ItemGroupBasicSectionFieldLabels2) => {
  ItemGroupBasicSectionFieldLabels2[ItemGroupBasicSectionFieldLabels2["active"] = 0] = "active";
  ItemGroupBasicSectionFieldLabels2[ItemGroupBasicSectionFieldLabels2["name"] = 1] = "name";
  ItemGroupBasicSectionFieldLabels2[ItemGroupBasicSectionFieldLabels2["posName"] = 2] = "posName";
  ItemGroupBasicSectionFieldLabels2[ItemGroupBasicSectionFieldLabels2["kdsName"] = 3] = "kdsName";
  ItemGroupBasicSectionFieldLabels2[ItemGroupBasicSectionFieldLabels2["checkName"] = 4] = "checkName";
  ItemGroupBasicSectionFieldLabels2[ItemGroupBasicSectionFieldLabels2["onlineName"] = 5] = "onlineName";
  ItemGroupBasicSectionFieldLabels2[ItemGroupBasicSectionFieldLabels2["required"] = 6] = "required";
  return ItemGroupBasicSectionFieldLabels2;
})(ItemGroupBasicSectionFieldLabels || {});
var ItemGroupItemsFieldLabels = /* @__PURE__ */ ((ItemGroupItemsFieldLabels2) => {
  ItemGroupItemsFieldLabels2[ItemGroupItemsFieldLabels2["active"] = 0] = "active";
  ItemGroupItemsFieldLabels2[ItemGroupItemsFieldLabels2["additionalPrice"] = 1] = "additionalPrice";
  ItemGroupItemsFieldLabels2[ItemGroupItemsFieldLabels2["sortPriority"] = 2] = "sortPriority";
  return ItemGroupItemsFieldLabels2;
})(ItemGroupItemsFieldLabels || {});
var returnLabel = (field) => {
  if (field in ItemGroupBasicSectionFieldLabels) {
    return i18n_config_default.t(
      `app.modals.itemsDiff.basic.${field}`
    );
  }
  if (field in ItemGroupItemsFieldLabels) {
    return i18n_config_default.t(
      `app.modals.combosDiff.itemOfItemGroup.${field}`
    );
  }
};
var diffItemGroupsFactory = (diffArray, state) => {
  if (diffArray.length > 0) {
    const diffObject = {
      basic: getDiffArray(
        diffArray,
        returnLabel,
        ItemGroupBasicSectionFieldLabels,
        1
      ),
      associations: generateAssociationsArray(diffArray, state)
    };
    return diffObject;
  }
  return null;
};
var generateAssociationsArray = (diffArray, state) => {
  const items = selectItems(state);
  const itemsArray = [];
  const ITEMS_FIELD = "items";
  diffArray.forEach(
    (diff) => filterDiffFunction(
      diff,
      ({ diffLength, newDiff }) => {
        if (diffLength === 1) {
          return;
        }
        const customField = diff.path[0];
        if (diff.kind === "N") {
          let changes = Object.entries(
            diff.rhs
          ).map(([itemOfItemGroupField, itemOfItemGroupValue]) => {
            return {
              field: itemOfItemGroupField,
              label: returnLabel(itemOfItemGroupField),
              value: itemOfItemGroupValue
            };
          });
          if (customField === ITEMS_FIELD) {
            changes = changes.filter(
              (change) => change.field in ItemGroupItemsFieldLabels
            );
            const itemId = diff.rhs.itemId;
            itemsArray.push({
              id: itemId,
              label: items[itemId].name,
              action: "add",
              changes
            });
          }
        } else if (diff.kind === "D") {
          if (customField === ITEMS_FIELD) {
            const itemId = diff.lhs.itemId;
            itemsArray.push({
              id: itemId,
              label: items[itemId].name,
              action: "remove",
              changes: []
            });
          }
        } else if (diff.kind === "E") {
          const id = Number(diff.path[1]);
          if (customField === ITEMS_FIELD) {
            if (!itemsArray.find(
              (item) => item.id === id && item.action === "update"
            )) {
              itemsArray.push({
                id,
                label: items[id].name,
                action: "update",
                changes: [newDiff]
              });
            } else {
              for (const [i, item] of itemsArray.entries()) {
                if (item.id === id) {
                  itemsArray[i].changes = [...item.changes, newDiff];
                  break;
                }
              }
            }
          }
        }
      },
      returnLabel
    )
  );
  return itemsArray;
};

export { ItemGroupBasicSectionFieldLabels, ItemGroupItemsFieldLabels, diffItemGroupsFactory };
